import React from "react";

export enum NavigationBarTheme {
  admin = "admin",
  student = "student",
}
export interface NavigationBarProps {
  links: Array<Array<any>>;
  ctaContainer?: React.ReactNode;
  activePath?: string;
  theme?: NavigationBarTheme;
}
